// extracted by mini-css-extract-plugin
module.exports = {"root":"ActionMenu_root__3SQX8","active":"ActionMenu_active__3BXY-"};